import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { FormattedMessage } from "react-intl";
import { MessageBox } from "../../../common";
import { ELIGIBILITY } from "../enums/synchronizationOptions";
import * as dataActions from "../../../../utils/data/dataActions";
import {
    getClientSyncs,
    isArchivedEventError,
    isClientEligibleForSync,
    isHashValid,
    getOverlayForSync,
} from "../../../common/synchronization/SynchronizationHelper";
import { RectangleSpinner } from "../../../common/spinners";
import OverlayWithToolTip from "../../../common/Overlay/OverlayWithToolTip";

class ClientSyncHeader extends Component {
    constructor(props) {
        super(props);
        this.state = { latestSyncs: null, loading: false };
        this.setLatestClientSyncs = this.setLatestClientSyncs.bind(this);
    }

    componentDidMount() {
        this.props.updateClientInfo();
        this.setLatestClientSyncs();
    }

    setLatestClientSyncs() {
        const { client } = this.props;

        if (client.syncType === ELIGIBILITY.value) this.setState({ loading: true });

        getClientSyncs(client.clientId).then((response) => {
            if (response) {
                this.setState({ latestSyncs: response, loading: false });
            } else {
                this.setState({ latestSyncs: null, loading: false });
            }
        });
        // Catch is already done in the getClientSyncs function
    }

    getMessageBox = () => {
        const { latestSyncs } = this.state;
        if (!latestSyncs) return null;

        const status = latestSyncs.status;
        let className;
        let messageId;
        const isValidHashStatus = isHashValid(this.props.client, latestSyncs, "clientPartnerHash", "clientPartnerHash");
        if (!isClientEligibleForSync(this.props.client) && !isArchivedEventError(latestSyncs)) {
            className = "alert-warning-no-sync";
            messageId = "notSynchronizable";

            const messageBox = (
                <MessageBox className={`client-synchronization-alert ${className}`}>
                    <FormattedMessage id={`clients.synchronizationStatus.${messageId}`} />
                </MessageBox>
            );

            return (
                <OverlayWithToolTip
                    placement="bottom"
                    toolTipId="clients.synchronizationStatus.nonSyncClient"
                    customComponent={messageBox}
                />
            );
        } else {
            switch (status) {
                case "SUCCESS":
                    if (isValidHashStatus) {
                        className = "alert-success";
                        messageId = "success";
                    }
                    else {
                        className = "alert-warning";
                        messageId = "notSynced";
                    }
                    break;
                case "FAILURE":
                    className = "alert-danger";
                    messageId = "failed";
                    break;
                case "STARTED":
                    className = "alert-warning";
                    messageId = "inProgress";
                    break;
                default:
                    className = "alert-warning";
                    messageId = "notSynced";
            }
        }
        if (className && messageId) {
            const messageBox = (
                <MessageBox className={`client-synchronization-alert ${className} ml-10`}>
                    <FormattedMessage id={`clients.synchronizationStatus.${messageId}`} />
                </MessageBox>
            );

            return getOverlayForSync(
                {"client": this.props.client},
                latestSyncs,
                "clients.datatable",
                "clientPartnerHash",
                "clientPartnerHash",
                "client",
                true,
                false,
                messageBox,
                "right"
            );
        }
        return null;
    };

    render() {
        const { loading, latestSyncs } = this.state;
        if (loading) {
            return <RectangleSpinner />;
        }
        if (latestSyncs) {
            return this.getMessageBox();
        }
        return null;
    }
}

ClientSyncHeader.propTypes = {
    client: PropTypes.object.isRequired,
    updateClientInfo: PropTypes.func,
    dataActions: PropTypes.object.isRequired,
};

function mapDispatchToProps(dispatch) {
    return {
        dataActions: bindActionCreators(dataActions, dispatch),
    };
}

export default connect(null, mapDispatchToProps)(ClientSyncHeader);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/ClientSyncHeader.js